import React from "react";
import { Pagination as ReactPagination, PaginationItem, PaginationLink } from "reactstrap";
import "./pagination.scss";
import { IPagination } from "../../interfaces/pagination";
import { ITEMS_PER_PAGE } from "../../utils/constants";
import { NextIcon, PreviousIcon } from "../../assets";

interface IProps extends IPagination {
	range?: number;
	handlePageChange: (page: number) => void;
	className?: string;
	paginatorSize?: "sm" | "md" | "lg" | "xs";
	loading?: boolean;
	isNextPageLoading?: boolean | undefined;
}

export const Pagination: React.FC<IProps> = ({
	className,
	page,
	pages,
	size = ITEMS_PER_PAGE,
	range = 5,
	handlePageChange,
	total,
	paginatorSize = "md",
	loading = false,
	isNextPageLoading
}) => {
	const paginateItems = [];
	let start = 1;
	let end = pages;

	// Ensure pages is at least 1
	if (pages < 1) {
		end = 1;
	}

	// Calculate the range of pages to display (e.g., 5 pages around the current page)
	if (pages > range) {
		const halfRange = Math.floor(range / 2);
		start = Math.max(1, page - halfRange);
		end = Math.min(pages, start + range - 1);

		// Adjust start if end exceeds total pages
		if (end === pages) {
			start = Math.max(1, pages - range + 1);
		}
	}

	for (let pageNumber = start; pageNumber <= end; pageNumber++) {
		paginateItems.push(
			<PaginationItem
				key={pageNumber}
				active={pageNumber === page}
				onClick={() => !loading && handlePageChange(pageNumber)}
				disabled={loading}
			>
				<PaginationLink disabled={loading}>{pageNumber}</PaginationLink>
			</PaginationItem>
		);
	}

	return (
		<div className={`pagination-wrapper ${className ? className : ""}`}>
			<ReactPagination size={paginatorSize}>
				{/* <PaginationItem>
                    <PaginationLink first onClick={() => handlePageChange(1)} />
                </PaginationItem> */}
				<PaginationItem disabled={loading || page === 1} className="previous-sec">
					<PaginationLink
						disabled={loading || isNextPageLoading || page === 1}
						previous
						onClick={() => !loading && page > 1 && handlePageChange(page - 1)}
					>
						<PreviousIcon className="nav-ic" />
						<span className="prev-lbl nav-lbl">Previous</span>
					</PaginationLink>
				</PaginationItem>

				{/* {Array.from(Array(pages).keys()).map(pageNumber => {
                    pageNumber++;
                    return (
                    
                    )
                })} */}

				{paginateItems}

				<PaginationItem disabled={loading || page === pages} className="next-sec">
					<PaginationLink
						disabled={loading || isNextPageLoading || page === pages}
						next
						onClick={() => !loading && page < pages && handlePageChange(page + 1)}
					>
						<span className="nxt-lbl nav-lbl">Next</span>
						<NextIcon className="nav-ic" />
					</PaginationLink>
				</PaginationItem>
				{/* <PaginationItem>
                    <PaginationLink last onClick={() => handlePageChange(pages)} />
                </PaginationItem> */}
			</ReactPagination>
		</div>
	);
};
